// @generated by TypeGen from NMEA/NMEAEntry.swift - DO NOT EDIT

export interface INMEADepth extends INMEAEntry {
  source: INMEASource;
  receivedAt: string;
  type: string;
  fathoms?: number;
  feet?: number;
  meters: number;
  transducerOffset?: number;
}

export interface INMEADistance extends INMEAEntry {
  source: INMEASource;
  receivedAt: string;
  logTotal: number;
  logSinceReset: number;
  logOverGroundTotal?: number;
  logOverGroundSinceReset?: number;
}

export interface INMEAEngine extends INMEAEntry {
  source: INMEASource;
  receivedAt: string;
  number: number;
  rpm: number;
}

export interface INMEAEntry {
  receivedAt: string;
  source: INMEASource;
  nmeaType: string;
}

export interface INMEAHeading extends INMEAEntry {
  source: INMEASource;
  receivedAt: string;
  type: string;
  courseTrue?: number;
  courseMagnetic?: number;
  speed?: number;
  variation?: number;
}

export interface INMEANavigation extends INMEAEntry {
  source: INMEASource;
  receivedAt: string;
  time: string;
  lat: number;
  lng: number;
  sog?: number;
  track?: number;
}

export interface INMEATime extends INMEAEntry {
  source: INMEASource;
  receivedAt: string;
  utc: number;
  day: number;
  month: number;
  year: number;
  timezoneOffset: number;
}

export interface INMEAWeather extends INMEAEntry {
  source: INMEASource;
  receivedAt: string;
  priority: boolean;
  temperature?: number;
  humidity?: number;
  pressure?: number;
}

export interface INMEAWind extends INMEAEntry {
  source: INMEASource;
  receivedAt: string;
  reference: INMEAWindReference;
  priority: boolean;
  relative: boolean;
  angle: number;
  speed: number;
}

export enum INMEADepthType {
  belowKeel = "DBK",
  belowSurface = "DBS",
  belowTransducer = "DBT",
  water = "DPT",
}

export enum INMEAHeadingType {
  overGround = "VTG",
  overWater = "VHW",
  headingTrue = "HDT",
  headingMagnetic = "HDM",
  headingMagnetic2 = "HDG",
}

export enum INMEASource {
  nmea = 1,
  native = 2,
}

export enum INMEAWindReference {
  apparent = "apparent",
  trueBoat = "trueBoat",
  trueDirection = "trueDirection",
}
